import { DwQueryRequest } from './types';

/** [AVA-18225]: Fix a BE issue with timestamps - use with historical queries. */
export const patchHistoricalQueryTimeRange = (timeRange: DwQueryRequest['timeRange']): DwQueryRequest['timeRange'] => {
  if (!timeRange || !timeRange.between) {
    return timeRange;
  }

  const [from, to] = timeRange.between.values;
  if (!to) {
    return timeRange;
  }

  const toDateWithoutMS = new Date(to);
  toDateWithoutMS.setMilliseconds(0);

  return {
    ...timeRange,
    between: {
      values: [from, toDateWithoutMS],
    },
  };
};
